import {RouterState} from 'connected-react-router';

import {AppState} from 'containers/App/redux/types';
import {TemplateState} from 'containers/ChooseTemplatePage/types';
import {WisbitState} from 'containers/WisbitPage/types';
import {ManageUserState} from 'containers/ManageUserPage/redux/types';
import {ManageWisbitState} from 'containers/ManageWisbitPage/types';
import {ManageOrganizationState} from 'containers/ManageOrganizationPage/redux/types';
import {ErrorState} from 'containers/ErrorPage/types';

export interface RootState {
  router: RouterState;
  app: AppState;
  template: TemplateState;
  wisbit: WisbitState;
  manageUser: ManageUserState;
  manageWisbit: ManageWisbitState;
  manageOrganization: ManageOrganizationState;
  error: ErrorState;
}

export function selectRouter(state: RootState) {
  return state.router;
}

export function selectApp(state: RootState) {
  return state.app;
}

export function selectTemplate(state: RootState) {
  return state.template;
}

export function selectWisbit(state: RootState) {
  return state.wisbit;
}

export function selectManageUser(state: RootState) {
  return state.manageUser;
}

export function selectManageWisbit(state: RootState) {
  return state.manageWisbit;
}

export function selectManageOrganization(state: RootState) {
  return state.manageOrganization;
}

export function selectError(state: RootState) {
  return state.error;
}
